import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';

const DeleteMilestoneDialog = (props) => {
  const {
    milestone,
    onCancel,
    onConfirm,
    loading = false,
    open,
    mode = 'delete',
  } = props;
  const isCancelMode = mode === 'cancel';

  return (
    <Dialog
      open={open ?? Boolean(milestone)}
      onClose={onCancel}
      fullWidth
      maxWidth='xs'
      aria-labelledby='milestone-delete-title'
      aria-describedby='milestone-delete-description'
      PaperProps={{
        sx: { p: 1, borderRadius: 2 },
      }}
    >
      <DialogTitle id='milestone-delete-title' sx={{ pb: 1 }}>
        {isCancelMode ? 'Cancel ' : 'Delete '}
        <Typography component='span' sx={{ fontWeight: 600 }}>
          "{milestone?.title || 'Untitled'}"
        </Typography>
      </DialogTitle>
      <DialogContent>
        {isCancelMode ? (
          <>
            <DialogContentText
              id='milestone-delete-description'
              sx={{ mb: 2, fontSize: '0.875rem', color: 'text.primary' }}
            >
              Are you sure you want to cancel this milestone?
            </DialogContentText>
            <Alert severity='warning' sx={{ mt: 1 }}>
              <Typography variant='body2' sx={{ fontSize: '0.8125rem' }}>
                This action is irreversible. The milestone will be cancelled
                (not deleted). Only a system administrator can revert this
                action.
              </Typography>
            </Alert>
          </>
        ) : (
          <>
            <DialogContentText
              id='milestone-delete-description'
              sx={{ mb: 2, fontSize: '0.875rem', color: 'text.primary' }}
            >
              Are you sure you want to delete the milestone?
            </DialogContentText>
            <Alert severity='warning' sx={{ mt: 1 }}>
              <Typography variant='body2' sx={{ fontSize: '0.8125rem' }}>
                This action cannot be undone. All associated data will be
                permanently deleted.
              </Typography>
            </Alert>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          color='error'
          variant='contained'
          onClick={onConfirm}
          disabled={loading}
          sx={{
            minWidth: loading ? 64 : 'auto',
            position: 'relative',
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: 'inherit' }} />
          ) : (
            isCancelMode ? 'Cancel' : 'Delete'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMilestoneDialog;
